<!--
 * @Author: liukai
 * @since: 2022-04-13 17:01:02
 * @LastAuthor: liukai
 * @lastTime: 2022-04-24 18:04:48
-->
<template>
  <div class="country">
    <!-- <Nav title="全国新冠肺炎实时动态"></Nav> -->
    <div class="focus_pic">
      <img :src="pic" alt="">
    </div>
    <div class="total_pain">
      <div class="float_hat">
      </div>
      <h3>国内疫情</h3> 
      <div class="pain_list">
          <div class="cell"> 
            <h5>新增本土确诊</h5>
            <p>{{overview.addLocalConfirm}}</p>
          </div>
          <div class="cell"> 
            <h5>新增无症状</h5>
            <p class="perple">{{overview.addAsymptomatic}}</p>
          </div>
          <div class="cell"> 
            <h5>新增境外输入</h5>
            <p class="red">{{overview.addOverseas}}</p>
          </div>
          <div class="cell"> 
            <h5>新增确诊</h5>
            <p class="red">{{overview.addConfirm}}</p>
          </div>
      </div>
      <div class="pain_list">
          <div class="cell"> 
            <h5>现有本土确诊</h5>
            <p>{{overview.existingLocalConfirm}}</p>
          </div>
          <div class="cell"> 
            <h5>现有无症状</h5>
            <p class="perple">{{overview.existingAsymptomatic}}</p>
          </div>
          <div class="cell"> 
            <h5>现有境外</h5>
            <p class="red">{{overview.existingOverseas}}</p>
          </div>
          <div class="cell"> 
            <h5>现有确诊</h5>
            <p class="red">{{overview.existingConfirm}}</p>
          </div>
      </div>
      <div class="sprite">
        <van-divider />
      </div>
      <div class="pain_list">
          <div class="cell"> 
            <h5>累计确诊</h5>
            <p class="brown">{{overview.aggregateConfirmAdd}}</p>
             <h4>
              累计
              <span class="num brown">{{overview.aggregateConfirm}}</span>
            </h4>
          </div>
          <div class="cell"> 
            <h5>累计境外</h5>
            <p class="darkRed">{{overview.aggregateOverseasAdd}}</p>
             <h4>
              累计
              <span class="num darkRed" >{{overview.aggregateOverseas}}</span>
            </h4>
          </div>
          <div class="cell"> 
            <h5>累计治愈</h5>
            <p class="green">{{overview.aggregateCureAdd}}</p>
             <h4>
              累计
              <span class="num green">{{overview.aggregateCure}}</span>
            </h4>
          </div>
          <div class="cell"> 
            <h5>累计死亡</h5>
            <p class="death">{{overview.aggregateDieAdd}}</p>
             <h4>
              累计
              <span class="num death">{{overview.aggregateDie}}</span>
            </h4>
          </div>
      </div>
    </div>
    <div class="list">
      <h3>近期31省份病例分布</h3>
      <van-row>
        <van-col span="4">
          <span class="area">城市 (区)</span>
        </van-col>
        <van-col span="4">
          <span class="area blue">
            省市区
          </span>
        </van-col>
        <van-col span="4">
          <span class="area listRed">
            新增确诊
          </span>
        </van-col>
        <van-col span="4">
          <span class="area longer perple">
            新增无症状
          </span>
        </van-col>
        <van-col span="4"><span class="area weak">
          现有确诊
          </span></van-col>
        <van-col span="4">
          <span class="area">
            累计确诊
          </span>
        </van-col>
      </van-row>
      <template v-for="(item,index) in datalist" :key="item.id">
        <van-row >
        <van-col span="4">
          <span :class="['area',index%2==0?'triggle':'','table']">{{item.city}}</span>
        </van-col>
        <van-col span="4">
          <span :class="['area',index%2==0?'triggle':'','table']">
            {{item.prov}}
          </span>
        </van-col>
        <van-col span="4">
          <span :class="['area',index%2==0?'triggle':'','table']">
            {{item.confirmAdd}}
          </span>
        </van-col>
        <van-col span="4">
          <span :class="['area',index%2==0?'triggle':'','table','longer']">
            {{item.wzzAsymptomatic}}
          </span>
        </van-col>
        <van-col span="4"><span :class="['area',index%2==0?'triggle':'','table']">
          {{item.existingConfirm}}
          </span></van-col>
        <van-col span="4">
          <span :class="['area',index%2==0?'triggle':'','table']">
            {{item.aggregateConfirm}}
          </span>
        </van-col>
      </van-row>
      </template>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav-bar.vue";
import { reactive, onMounted, toRefs,onBeforeMount } from "vue";
import {Divider,Col,Row } from 'vant'
import {getnationwide} from "@/api/"
export default {
    name:'country',
    components:{
        Nav,
        [Divider.name]:Divider,
         [Col.name]:Col ,
        [Row.name]:Row , 
        
    },
   setup(){
     const data=reactive({
        pic:require("@/assets/img/country.jpg"),
        datalist:[
          {
             aggregateConfirm: "35077",
          city: "上海",
          confirmAdd: "2494",
          existingConfirm: "22130",
          id: 1,
          prov: "上海",
          updateTime: "2022-04-20 15:47:15",
          wzzAsymptomatic: "16407",
          }
        ],
        overview:{
          addAsymptomatic: "+17166",
          addConfirm: "+4582",
          addLocalConfirm: "+2753",
          addOverseas: "+8",
          aggregateConfirm: "541313",
          aggregateConfirmAdd: "4582",
          aggregateCure: "237664",
          aggregateCureAdd: "+2962",
          aggregateDie: "14687",
          aggregateDieAdd: "+26",
          aggregateOverseas: "18050",
          aggregateOverseasAdd: "+8",
          existingAsymptomatic: "266288",
          existingConfirm: "288962",
          existingLocalConfirm: "30537",
          existingOverseas: "236",
          id: 1,
          statisticsTime: 1650440411,
          updateTime: "2022-04-20 15:47:15",
        }

     })

     const methodsMap={
       requestGetnationwide:()=>{
         getnationwide().then(res=>{
            console.log(res)
           if(res.data.code==0){
             let orderList=res.data.data.list;
                orderList.sort((a,b)=>{
                  if(b.confirmAdd=='待公布'){
                    return -1
                  }
                  return b.confirmAdd-a.confirmAdd
                })
              data.datalist = orderList
             data.overview=res.data.data.overview
           }
         })
       }
     }
    onMounted(()=>{
      // methodsMap.requestGetnationwide()
    })
    onBeforeMount(()=>{
      methodsMap.requestGetnationwide();

    })
     return{
       ...toRefs(data),
       ...methodsMap
     }
   }
}
</script>

<style lang="scss" >
@import '@/css/wap/mixin.scss';
.country{
    width: 375px;
    background-color: #fff;
    overflow-x: hidden;
    min-height: 100vh;
    .focus_pic{
      img{
        width: 375px;
        height: 210px;

      }
    }
   .total_pain{
     position: relative;
     padding: 15px;
     .float_hat{
      width: 375px;
      height: 20px;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      position: absolute;
      top:-12px;
      left:0;
      background-color: #fff;
    }
    h3{
      color: #444444;
      font-weight: bold;
      font-size: 16px;
      
    }
    .sprite{
      width: 345px;
      margin: 0 auto;
    }
    .pain_list{
      margin-top: 16px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      .cell{
        width: 86px;
        height: 53px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        @include noWrap;
        overflow: hidden;
        h5{
            color: #444444;
            font-weight: 500;
            font-size: 12px;
            
        }
        p{
          color: #eda546;
          font-weight: bold;
          font-size: 15px;
          text-align: center;
          width: 86px;
            @include noWrap;
        }
        h4 {
          font-size: 10px;
          color: #444444;
          width: 86px;
          @include noWrap;
          text-align: center;
        }
        .perple{
          color:#AC45CD;
        }
        .red{
          color:#D82E2A
        }
        .brown{
          color:#962928
        }
        .green{
          color:#25A481
        }
        .death{
          color: #102A4D;
        }
        .darkRed{
          color:#B92C33
        }

      }
    }
   }
   .list{
     width: 345px;
     margin: 0 auto;
     padding-bottom: 30px;
     h3{
      color: #444444;
      font-weight: bold;
      font-size: 16px;
      margin: 6px 0;
    }
    .area{
      display: inline-block;
      height: 36px;
      width: 57px;
      line-height: 36px;
      text-align: center;
      color: #444444;
      font-family: PingFang SC;
      font-weight: 600;
      font-size: 12px;
    }
    .longer{
      width: 60px;
    }
    .blue{
      color: #4A5EC7;
    }
    .listRed{
      color:#DB2F20
    }
    .perple{
          color:#AC45CD;
        }
    .weak{
      color:#999999
    }    
    .table{
      font-weight: normal;

    }
    .triggle{
      background-color: #FAFAFA;
    }

   } 
}
</style>